export { openMetric, openAlert, openSources, openTimeMachine } from '../../app/home/open'
import { navigate } from '../../app/router'
import { useUi } from '../../app/ui'
import { timeCursor } from '../../app/time/cursor'
import { useApp } from '../store'
import { afterPaint } from './afterPaint'
let cancelForecastScroll = () => {}
export function openForecast() {
  cancelForecastScroll()
  navigate('/')
  // History restores its old scroll after popstate; apply the explicit tab intent afterwards.
  cancelForecastScroll = afterPaint(() => {
    if (location.pathname !== '/') return
    const reduced = useApp.getState().motion === 'reduced' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' })
  })
}
export const openPlaces = () => useUi.getState().setPhoneList(true)
export const openSettings = () => navigate('/settings')
export const openMap = () => navigate(`/map${timeCursor.selected == null ? '' : `?t=${timeCursor.selected}`}`)
export const goNow = () => { timeCursor.toNow(); timeCursor.flush() }
